import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { ReceptionStatusManagerOverviewQueryDocument } from '@docpace/reception-status-graphql/dist/urql.types'
import { ReceptionStatusManagerOverviewQueryResultFragment } from '@docpace/reception-status-graphql'

const typedReceptionStatusManagerOverviewQueryDocument = ReceptionStatusManagerOverviewQueryDocument as TypedDocumentNode<ReceptionStatusManagerOverviewQueryResultFragment>

export function useReceptionStatusManagerOverviewQuery(opts?: useQuery.Options<ReceptionStatusManagerOverviewQueryResultFragment>){
    return useQuery(typedReceptionStatusManagerOverviewQueryDocument, opts)
}
